<template>
  <Teleport to="body">
    <UIBaseTransition :name="UIStore.getDynamicSidePanel.animation">
      <Component
        :is="UIStore.getDynamicSidePanel.component"
        v-bind="UIStore.getDynamicSidePanel.data"
        v-model="UIStore.getDynamicSidePanel.value"
        v-on="UIStore.getDynamicSidePanel.events"
        @update:model-value="UIStore.cleanSidePanel"
      />
    </UIBaseTransition>
  </Teleport>
</template>

<script setup lang="ts">
const UIStore = useUIStore();
</script>

<style scoped></style>
